/* eslint-disable */
/*
  DS_19 — cart drawer interaction tracking (GA4 dataLayer).
  Ported from the won Intelligems DS_19 variant's tracking script so the
  interaction events keep flowing after the theme-native rollout. Mobile only
  (<= 767px), matching the population the experiment measured. Dropped from
  the won script: the Intelligems goal pushes, the Clarity "AB-Test" tag and
  the "Test / DS_19_Var" pageview event — all three label a session as an
  experiment variant, which is meaningless once the feature is live for everyone.
*/
if (!window.DS_19_trackingVar) {
    window.DS_19_trackingVar = true;
    (function trackingVar() {
        if (document.documentElement.clientWidth > 767) return;

        function waitUntil(predicate, success, error) {
            let int = setInterval(() => {
                if (predicate()) {
                    clearInterval(int);
                    int = null;
                    success();
                }
            }, 100);
            setTimeout(() => {
                if (int !== null) {
                    clearInterval(int);
                    if (typeof error === 'function') {
                        error();
                    }
                }
            }, 20000);
        }

        function ga4Tracking(category, action, label) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Intelligems_Test_Tracking',
                category,
                action,
                label
            });
        }

        function delegateEvent(el, evt, sel, handler) {
            el.addEventListener(evt, function (event) {
                let t = event.target;
                while (t && t !== this) {
                    if (t.matches(sel)) {
                        event.matchedSelector = t;
                        handler.call(t, event);
                    }
                    t = t.parentNode;
                }
            });
        }

        setTimeout(() => {
            delegateEvent(document, 'mousedown', 'body', function ({ target }) {

                // View Offers Interaction (native <details> toggle — open state flips after this event)
                if (target.closest('.ds19-savings__summary')) {
                    const willClose = target.closest('.ds19-savings').open;
                    ga4Tracking('DS_19', 'View Offers Interaction', willClose ? 'close' : 'open');
                }

                // Cart- Product Image Interaction
                if (target.closest('.site-header__cart .cart__item .cart__image .image-wrap')) {
                    const productName = target.closest('.cart__item').querySelector('.cart__item-name');
                    ga4Tracking('DS_19', 'Cart- Product Image Interaction', productName.textContent.trim());
                }

                // Cart- Product name Interaction
                if (target.closest('.site-header__cart .cart__item .cart__item-name')) {
                    const productName = target.closest('.cart__item').querySelector('.cart__item-name');
                    ga4Tracking('DS_19', 'Cart- Product name Interaction', productName.textContent.trim());
                }

                // Cart- Qty Selector Interaction
                if (target.closest('.site-header__cart .cart__item .js-qty__wrapper .js-qty__adjust')) {
                    const isPlus = target.closest('.js-qty__adjust--plus');
                    ga4Tracking('DS_19', 'Cart- Qty Selector Interaction', isPlus ? '+' : '-');
                }

                // Shop best selling Arrow Interaction
                if (target.closest('.site-header__cart .cart-drawer-addons .cart-drawer-addons__nav .cart-drawer-addons__arrow')) {
                    const heading = target.closest('.cart-drawer-addons__header').querySelector('.cart-drawer-addons__title');
                    const isBestSelling = heading && heading.textContent.toLowerCase().includes('best selling');
                    if (isBestSelling) {
                        const isLeftArrow = target.closest('.cart-drawer-addons__arrow--prev');
                        ga4Tracking('DS_19', 'Shop best selling Arrow Interaction', isLeftArrow ? 'Left' : 'Right');
                    }
                }

                // Shop best selling Interaction
                if (target.closest('.site-header__cart .cart-drawer-addon')) {
                    const heading = target.closest('.cart-drawer-addons').querySelector('.cart-drawer-addons__title');
                    const isBestSelling = heading && heading.textContent.toLowerCase().includes('best selling');
                    if (isBestSelling) {
                        const image = target.closest('.cart-drawer-addon__image');
                        const title = target.closest('.cart-drawer-addon__title');
                        const variant = target.closest('.cart-drawer-addon__options');
                        const a2cBtn = target.closest('.cart-drawer-addon__add-btn');
                        let label = '';
                        if (image) label = 'Product Img';
                        else if (title) label = 'Product Name';
                        else if (variant) label = 'variant Selection';
                        else if (a2cBtn) label = 'Add Interaction';

                        if (label) {
                            ga4Tracking('DS_19', 'Shop best selling Interaction', `Interaction with ${label}`);
                        }
                    }
                }

                // Shipping Protection Toggle Interaction
                if (target.closest('.site-header__cart .cart__footer #shippingProtectionCheckBox')) {
                    const isChecked = target.closest('#shippingProtectionCheckBox').checked;
                    ga4Tracking('DS_19', 'Shipping Protection Toggle Interaction', `${isChecked ? 'OFF' : 'ON'}`);
                }

                // Secure Checkout Interaction
                if (target.closest('.site-header__cart .cart__footer button[type="submit"][name="checkout"]')) {
                    ga4Tracking('DS_19', 'Secure Checkout Interaction', '');
                }

                // Reassurance Interaction
                if (target.closest('.ds02-trust__item')) {
                    ga4Tracking('DS_19', 'Reassurance Interaction', target.closest('.ds02-trust__item').textContent.trim());
                }

                // mini cart close interaction
                if (target.closest('.site-header__cart .cart__header--close-btn')) {
                    ga4Tracking('DS_19', 'mini cart close interaction', '');
                }
            });


            // Mini Cart opens
            waitUntil(() => document.querySelector('.site-header__cart'), () => {
                const cartWrapper = document.querySelector('.site-header__cart');
                // One push per mutation batch: the class check reads current state, so
                // iterating the records would emit duplicates.
                const observer = new MutationObserver(() => {
                    const hasIsActive = cartWrapper.classList.contains('is-active') && !cartWrapper.classList.contains('is-transitioning');

                    if (hasIsActive) {
                        ga4Tracking('DS_19', 'Mini Cart opens', '');
                    }
                });

                observer.observe(cartWrapper, { attributes: true, attributeFilter: ['class'] });
            });


            // Shop best selling Swipe Interaction
            waitUntil(() => document.querySelector('.cart-drawer-addons .cart-drawer-addons__list'), () => {
                const element = document.querySelector('.cart-drawer-addons__list');
                const heading = element.closest('.cart-drawer-addons').querySelector('.cart-drawer-addons__title');
                const isBestSelling = heading && heading.textContent.toLowerCase().includes('best selling');
                if (!isBestSelling) return;

                let startX = 0;
                let startY = 0;
                const minSwipeDistance = 30;

                element.addEventListener('touchstart', (e) => {
                    startX = e.touches[0].clientX;
                    startY = e.touches[0].clientY;
                });

                element.addEventListener('touchend', (e) => {
                    const endX = e.changedTouches[0].clientX;
                    const endY = e.changedTouches[0].clientY;

                    const diffX = startX - endX;
                    const diffY = startY - endY;


                    if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > minSwipeDistance) {
                        const action = diffX > 0 ? 'Right' : 'Left';
                        ga4Tracking('DS_19', 'Shop best selling Swipe Interaction', action);
                    }
                });
            });

        }, 1000);
    }());
}
